import React, { useEffect, useState } from "react";
import MailContactPicto from "../../Ressources/Images/MailContactPicto.svg";
import "./ContactButton.css";
import { getCurrentUser } from "../../Features/LocalStorage/LocalStorageUtility";
import axiosInstance from "../../Services/AxiosAPICaller";

const ALLOWED_ADMIN_EMAILS = ["ali.ben-hammouda@edf.fr", "joel.chantot@edf.fr"];

const ContactButton: React.FC = () => {
  const user = getCurrentUser();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const [admins, setAdmins] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const GetEDF_Admins = async () => {
      try {
        const UserExistresponse = await axiosInstance.get(
          `/users?populate[role][field][0]=name&&filters[role][name][$eq]=EDF_Admin`
        );

        const filteredAdmins = UserExistresponse.data.filter(
          (admin: any) =>
            !admin.email?.includes("joonsoft.fr") &&
            ALLOWED_ADMIN_EMAILS.includes(admin.email)
        );

        return filteredAdmins;
      } catch (error) {
        console.error("Error while trying to Get the EDF_Admins:", error);
        return [];
      }
    };

    const TryMeAndRoleAPI = async () => {
      try {
        const MeAndRole = await axiosInstance.get("/users/me?populate=role");
        const userData = MeAndRole.data;

        if (userData?.role) {
          const isEdfAdmin = userData.role.id === 4;
          console.log(
            isEdfAdmin ? "User is an EDF_admin" : "User is not an EDF_admin"
          );
          return isEdfAdmin;
        }

        console.log("Role not found in user data!");
        return false;
      } catch (error) {
        console.error("API Error", error);
        return false;
      }
    };

    const fetchData = async () => {
      setIsLoading(true);

      try {
        if (user) {
          const adminStatus = await TryMeAndRoleAPI();
          setIsAdmin(adminStatus);
        } else {
          setIsAdmin(false);
        }

        const adminsList = await GetEDF_Admins();
        setAdmins(adminsList);
      } catch (error) {
        console.error("Error fetching contact data:", error);
        setIsAdmin(false);
        setAdmins([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [user]);

  let mailtoTarget = "#";
  if (isAdmin === true) {
    mailtoTarget = "mailto:contact@joonsoft.fr";
  } else if (admins.length > 0) {
    const adminEmails = admins
      .filter((admin) => admin.email)
      .map((admin) => admin.email);

    if (adminEmails.length > 0) {
      mailtoTarget = `mailto:${adminEmails.join(",")}`;
    }
  }

  const handleClick = () => {
    if (isLoading) {
      return;
    }

    if (mailtoTarget !== "#") {
      window.location.href = mailtoTarget;
    } else {
      alert("No admin user available to contact.");
    }
  };

  return (
    <img
      src={MailContactPicto}
      className={`ContactMailIcon ${isLoading ? "loading" : ""}`}
      alt="Contact Us"
      onClick={handleClick}
      style={{
        cursor: isLoading ? "wait" : "pointer",
        opacity: isLoading ? 0.6 : 1,
      }}
    />
  );
};

export default ContactButton;
